import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { ErrorResponse } from '@coreModels/error-response';
import { SentryService } from './../sentry.service';

interface StoreFailureException {
  type: string;
  payload: ErrorResponse;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private sentryService: SentryService) {}

  handleError(error: Error | HttpErrorResponse | StoreFailureException) {
    this.sentryService.error = error;

    if (this.sentryService.isStoreException(error)) {
      return this.sentryService.handleHttpErrorResponse((error as StoreFailureException).payload);
    }
    if (this.sentryService.isServerError()) {
      return this.sentryService.handleHttpErrorResponse(error as HttpErrorResponse);
    }
    if (this.sentryService.CHUNK_FAILED_MESSAGE.test(error.message)) {
      window.location.reload();
      return;
    }

    this.sentryService.addSentryLog();
    this.sentryService.throwError();
  }
}
